<div class="compact-address-details-container">
  <div *ngIf="isBillingAddress" class="bold address-type">
    <span id="addressType">{{addressType | injectedText | async }}</span>
  </div>
  <div class="address-details">
    <div>
      <span>{{addressData?.company}}</span>
    </div>
    <div class="bold">
      <span id="firstName">{{addressData?.firstName}}</span>
      <span id="lastName"> {{addressData?.lastName}}</span>
    </div>
    <div>
      <span id="street">{{addressData?.street}}</span>
      <span id="streetNumber"> {{addressData?.streetNumber}}</span>
    </div>
    <div>
      <span id="zipCode">{{addressData?.zipCode}}</span>
      <span id="city"> {{addressData?.city}}</span>
    </div>
    <div>
      <span> {{addressData?.addressSupplement}}</span>
    </div>
    <div>
      <span id="country">{{addressData?.countryName}}</span>
    </div>
  </div>
</div>
